import { render, staticRenderFns } from "./floorElevator.vue?vue&type=template&id=2c2b771e&scoped=true&"
import script from "./floorElevator.vue?vue&type=script&lang=js&"
export * from "./floorElevator.vue?vue&type=script&lang=js&"
import style0 from "./floorElevator.vue?vue&type=style&index=0&id=2c2b771e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2b771e",
  null
  
)

export default component.exports